module.exports = __webpack_public_path__ + "img/enter_default_logo.444803eb.png";